import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import alertify from "alertifyjs"
import { setProduct2d } from '../../../redux/actions/product2dActions';

export const useProductSizes = (defaultSize = 'L') => {
    const dispatch = useDispatch()
    const product2d = useSelector((state: any) => state.product2d)
    const makFabric = useSelector((state: any) => state.makFabric)

    const products = useSelector(({ products }: any) => products);
    const { sizeColorMapping, skuArray } = products
    const sizes = sizeColorMapping ? Object.keys(sizeColorMapping).map((size) => ({
        size,
        label: size
    })) : [];

    const [currentSize, setCurrentSize] = useState({
        size: sizes.length ? sizes[0].size : defaultSize,
        label: sizes.length ? sizes[0].size : defaultSize,
    });

    useEffect(() => {
        setCurrentSize({
            size: product2d.size,
            label: product2d.size
        })
    }, [product2d])

    const handleSelectSize = useCallback((selectedSize) => {
        const newSelection = skuArray.find((item: any) => {
            return (item.color === product2d.color) && (item.size === selectedSize.size)
        })

        if (!newSelection) {
            const newSize = selectedSize.size;
            const newLabel = selectedSize.label;
            alertify.confirm('Sorry! The selected size is unavailable for the current color. Do you still wish to proceed?', () => {
                setCurrentSize({
                    size: newSize,
                    label: newLabel,
                })

                const color = sizeColorMapping[newSize][0].color;

                const newDefaultSelection = skuArray.find((item: any) => {
                    return (item.color === color) && (item.size === newSize)
                })

                const selection = {
                    ...product2d,
                    color,
                    variationSKU: newDefaultSelection.sku,
                    price: newDefaultSelection.price,
                    size: newSize
                }
                dispatch(setProduct2d(selection))
                makFabric.setBaseColor(color)
            });
            return
        }

        setCurrentSize({ ...selectedSize })

        const selection = {
            ...product2d,
            variationSKU: newSelection.sku,
            price: newSelection.price,
            size: selectedSize.size
        }

        dispatch(setProduct2d(selection))
    },
        [dispatch, makFabric, product2d, skuArray, product2d],
    )

    return{
        currentSize,
        handleSelectSize,
        sizes
    }
}